// take num, format to 2 decimal places then add commas in thousands place
//that fix javascript error that some times add multiple decimals
// returns a string
export default function formatNumberWithCommas(num) {
  if (typeof num === "number") {
    return num
      .toFixed(2)
      .toString()
      .replace(/\B(<\.\d*)(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return num
  }
}
